import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import {
    CreateProductAttribute,
    ProductAttribute,
    ProductAttributeListResponse,
    ProductAttributeQueryParams,
    UpdateProductAttribute
} from '@frontend/product/types';

export class ProductAttributeClient extends APIClient {
    public static readonly endpoint = '/product-api/v1';

    public static async fetchProductAttributes(
        queryParams?: ApiQueryParams<DefaultQueryParams | ProductAttributeQueryParams>
    ): Promise<ProductAttributeListResponse> {
        return await this.apiPaginated<ProductAttributeListResponse, DefaultQueryParams>(`${this.endpoint}/product-attributes`, queryParams);
    }

    public static async resolveProductAttributes(ids: string[], field: string = 'id'): Promise<ProductAttributeListResponse> {
        const response = await this.post(`${this.endpoint}/product-attributes-resolve`, { ids: ids, field: field });
        return await this.handleResponse<ProductAttributeListResponse>(response);
    }

    public static async deleteProductAttributes(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/product-attributes-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postProductAttribute(accountId: string, productId: string, body: CreateProductAttribute): Promise<ProductAttribute> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/products/${productId}/product-attributes`, body);
        return await this.handleResponse<ProductAttribute>(response);
    }

    public static async fetchProductAttribute(accountId: string, productId: string, productAttributeId: string): Promise<ProductAttribute> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/products/${productId}/product-attributes/${productAttributeId}`);
        return await this.handleResponse<ProductAttribute>(response);
    }

    public static async patchProductAttribute(
        accountId: string,
        productId: string,
        productAttributeId: string,
        body: UpdateProductAttribute
    ): Promise<ProductAttribute> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/products/${productId}/product-attributes/${productAttributeId}`, body);
        return await this.handleResponse<ProductAttribute>(response);
    }

    public static async deleteProductAttribute(accountId: string, productId: string, productAttributeId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/products/${productId}/product-attributes/${productAttributeId}`);
        return await this.handleVoidResponse(response);
    }
}
